import { getLocale } from "../runtime";

const sv_shortdatedcampaigntext = /** @type {(inputs: {date: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Bäst före: ${inputs.date}. Gäller så länge lagret räcker.`
};

const shortdatedcampaigntext = /** @type {(inputs: {date: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_shortdatedcampaigntext(inputs)
	return "shortDatedCampaignText";
};

export { shortdatedcampaigntext as "shortDatedCampaignText" };